module.exports = __webpack_public_path__ + "static/media/1549577033236-1900204673.b859d5da.jpg";